import React from 'react';

/**
 * SortableTh — reusable <th> with click-to-sort behaviour.
 * Pairs with the useSortableData hook.
 *
 * Props:
 *   sortKey: the data key this column sorts by
 *   currentSortKey, currentSortDir: from useSortableData
 *   onSort(key): from useSortableData.requestSort
 *   align: 'left' | 'right' | 'center' (default 'left')
 *   className: optional extra classes
 *   children: header label content
 */
const SortableTh = ({
  sortKey,
  currentSortKey,
  currentSortDir,
  onSort,
  align = 'left',
  className = '',
  children,
  ...rest
}) => {
  const active = currentSortKey === sortKey;
  const indicator = !active ? '↕' : currentSortDir === 'asc' ? '▲' : '▼';
  const alignClass =
    align === 'right' ? 'text-right' : align === 'center' ? 'text-center' : 'text-left';

  return (
    <th
      onClick={() => onSort(sortKey)}
      className={`px-4 py-3 ${alignClass} text-xs font-medium text-gray-500 uppercase cursor-pointer select-none hover:bg-gray-100 ${className}`}
      data-testid={`sort-${sortKey}`}
      {...rest}
    >
      <span className="inline-flex items-center gap-1">
        {children}
        <span className={`text-[10px] ${active ? 'text-blue-600' : 'text-gray-300'}`}>{indicator}</span>
      </span>
    </th>
  );
};

export default SortableTh;
